module.exports = __webpack_public_path__ + "static/img/1.4dc6069.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/1.png
// module id = fWoG
// module chunks = 0